class Retryer {
    constructor({
        max = 1,
        retries = 0,
    } = {}) {
        this.max = max
        this.retries = retries
    }

    canRetry = () => this.retries < this.max

    retry = () => {
        this.retries += 1
    }
}

export default Retryer
